// Rabat rezerwacji w groszach (N.6, 3.11.2026). LUSTRO Login/backend/lib/wartoscRezerwacji.js
// (`rabatGr`, `procentWGroszach`), z którego liczą faktura z rezerwacji, link do zapłaty i Statystyki;
// zgodność wykonuje Login/backend/tests/rabatRezerwacjiLustro.test.js. Plik jest czysty, bez importów,
// bo test serwera wykonuje go poza Reactem.
//
// Rabat procentowy to kwota razy procent, zaokrąglona do grosza od połowy w górę, na liczbach
// całkowitych; wartość rezerwacji to kwota minus ten rabat. Do 3.11.2026 panel odejmował rabat bez
// zaokrąglenia i zaokrąglał dopiero wynik, więc 50,10 zł minus 5% dawało w szczegółach rezerwacji
// 47,60 zł, a na fakturze 47,59 zł.

const dodatni = (x) => {
  const n = Number(x);
  return Number.isFinite(n) && n > 0 ? n : 0;
};

/** `procent` procent z `sumaGr` groszy, do grosza od połowy w górę (procent ma najwyżej 2 miejsca po przecinku). */
export function procentWGroszach(sumaGr, procent) {
  const setne = Math.round(procent * 100);
  const n = Math.round(sumaGr) * setne;
  return (n - (n % 10000)) / 10000 + (n % 10000 >= 5000 ? 1 : 0);
}

/**
 * Rabat w groszach od sumy `sumaGr` (grosze), przycięty do sumy; jednostka 'PLN' albo '%', inna nie
 * daje rabatu. Suma zero albo ujemna nie dostaje rabatu, rabat ujemny albo nieliczbowy to brak rabatu.
 */
export function rabatWGroszach(sumaGr, rabat, jednostka) {
  if (!(sumaGr > 0)) return 0;
  const d = dodatni(rabat);
  if (!d) return 0;
  const j = String(jednostka || '').toUpperCase();
  let gr;
  if (j === 'PLN') gr = Math.round((Math.round((d + Number.EPSILON) * 100) / 100) * 100);
  else if (j === '%') gr = d >= 100 ? sumaGr : procentWGroszach(sumaGr, d);
  else return 0;
  return Math.min(gr, sumaGr);
}
